export default __webpack_public_path__ + "static/media/Netflix3.2cd9eb84.png";